<template>
  <div>
    <!-- Booking Done Message -->
    <div class="style-container">
      <div class="px-3 mb-5">
        <div class="style-header scss-bold">Booking Done!</div>

        <div class="mt-5">
          <img src="@/assets/icons/green-tick.png" class="style-icon" />
        </div>

        <div class="mt-5 text-center scss-medium-font scss-text-white-space-preserved">
          {{ message }}
        </div>
      </div>
    </div>

    <!-- Homepage Button -->
    <div class="scss-button-position-bottom">
      <default-button title="Home" @click="goToHomePage" />
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
import { mapMutations } from "vuex";
import { ticketStatusList } from "@/common/constant/TicketStatus";

export default {
  name: "BookingDone",
  data() {
    return {
      status: ticketStatusList.CONFIRMED,
    };
  },
  components: { DefaultButton },
  computed: {
    message() {
      return this.status === ticketStatusList.REQUEST ?
        "Booking Requested, Your booking has been received and pending review. \n Details have been emailed to you. We will keep you updated!" :
        "Your booking has been confirmed. \n Details have been emailed to you. See you soon!";
    }
  },
  methods: {
    goToHomePage() {
      this.$router.push("/home");
    },
    ...mapMutations(["getBookingList"]),
  },
  created() {
    this.status = sessionStorage.getItem("booking-status");

    // Remove bookinglist item
    this.getBookingList(null);
    sessionStorage.removeItem("timeslot");
    sessionStorage.removeItem("serviceDetails");
  },
};
</script>

<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: $text-green;
  font-size: 18px;
}

.style-icon {
  width: 40%;
  height: 40%;
}
</style>
